<template>
  <div
    class="base-tabs-tab"
    :class="{
    'base-tabs-tab--active': active,
    'base-tabs-tab--disabled': lockerText,
  }"
    @click="!lockerText ? $emit('click') : null"
  >
    <BaseFeatureLocker v-if="lockerText" :tooltip-text="lockerText" :size="'xs'"></BaseFeatureLocker>
    <slot/>
    <div
      v-if="hasError"
      :class="`base-tabs-tab__badge base-tabs-tab__badge--error base-tabs-tab__badge--${errorColor}`"
    >!
    </div>
    <div v-if="badgeText" class="base-tabs-tab__badge">{{ badgeText }}</div>
    <slot name="icon"/>
  </div>
</template>

<script>
import BaseFeatureLocker
  from '@/views/RenovaDashboard/components/ui-kit/Cards/BaseFeatureLocker';

export default {
  name: 'BaseTabsTab',
  components: {BaseFeatureLocker},
  props: {
    /**
     * is current tab active
     */
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasError: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorColor: {
      type: String,
      default: 'red',
      validate: (value) => ['red', 'blue'].includes(value),
    },
    badgeText: {
      type: [String, Number],
      required: false,
      default: '',
    },
    lockerText: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.base-tabs-tab {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;
  background: #FFFFFF;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  cursor: pointer;

  font-weight: 500;
  font-size: 14px;
  line-height: 16px;

  color: var(--solid-dark-purple);
  border: none;
  white-space: nowrap;

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 16px;
    border-right: 1px solid var(--solid-lavender-grey);
    right: 0;
  }

  &--active {
    border: 1px solid var(--solid-black-purple);
    color: var(--solid-black-purple);
    cursor: default;
    margin: -1px;
    z-index: 1;

    &:after {
      display: none;
    }
  }
  &--disabled {
    border: none !important;
    color: var(--solid-dark-purple) !important;
    cursor: default;
    pointer-events: auto;
  }

  &:last-child:after {
    display: none;
  }

  &__badge {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px;
    height: 16px;
    background: var(--solid-dark-purple);
    border-radius: 16px;

    font-weight: 600;
    font-size: 11px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;

    &--error {
      width: 16px;
    }

    &--red {
      background: var(--solid-red);
    }

    &--blue {
      background: var(--solid-purple);
    }
  }
}
</style>
